import Vue from 'vue';
import CKEditor from 'ckeditor4-vue';

// CKEditor.config.coreStyles_underline = {
//     element: 'span',
//     attributes: { 'class': 'Underline' }
// };






Vue.use( CKEditor );
